import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '../../shared/base.component';
import { AppService } from '../../app.service';
import { AuthService } from '../../core/auth.service';
import { BaseService } from '../../shared/base.service';
import { QuestionnairesService } from '../questionnaires/questionnaires.service';
import { PatientService } from '../patient.service';
import { FormBuilder, Validators } from '@angular/forms';
import { PatientsService } from '../../patients/patients.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import * as _ from 'lodash';
import { ServiceProviderCategory } from './service-provider-category.model';
import { Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import {ModalDirective} from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-therapy-offers',
    templateUrl: 'therapy-offers.component.html',
    styleUrls: ['therapy-offers.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class TherapyOffersComponent extends BaseComponent implements OnInit {

    @Input() patientId: any;
    @Input() documents: any;
    @Input() questionnaires: any;

    @Output() navigateDocumentTab = new EventEmitter<any>();
    @ViewChild('tinymce', { static: false }) tinymce;
    @ViewChild('modalEdit',  {static: false}) modalEdit: ModalDirective;

    patientSub: Subscription;
    languageSub: Subscription;

    countries: any;
    insurances: any;
    insurancesCollection = [];
    selectedCountry: number = 1;
    selectedInsurances: any;
    groupTherapy = 0;
    lang: string = this.translate.currentLang;
    select2Options = {
        multiple: true,
        cssImport: true,
        // matcher: true,
        templateSelection: function (state) {
            if (state['display']) {
                return state[state['display']];
            }
            return state['text'];
        }
    };
    serviceProviders: any;
    serviceProvidersFiltered: any;
    zipcodeFilters = [];
    languageFilters = [];
    therapyStep = 1;
    previousStep = 0;
    STEPS = {
        FILTER_SERVICE_PROVIDER: 1,
        FIND_MATCHING_SERVICE_PROVIDER: 2,
        CHECK_CONTRAINDICATION: 3,
        PREVIEW_REPORT: 4,
        LASTSTEP: 5,
    };
    ld = _;
    filterBy = {
        languages: null,
        zip_code: null
    };
    countSelected = 0;
    dataUpdated = false;
    categorySelected = [];
    SPSelected = [];
    contrainSelected = [];
    contrainReviewed = [];
    pdfStyleCss: any;
    pdfContent: any;
    pdfFullcontent = '';
    previewHasBeenEditted = false;
    editContent = '';
    editingIndex = 0;
    editingItem: any;
    questionnaireId = 0;

    readonly serviceProvidersTableColumns = [
        ['name', 'Service provider', 'col-xs-4 col-sequence', 'text', 'custom', 'default'],
        ['insurance', 'Compensation', 'col-xs-3 col-insurance', 'text', 'custom', 'default'],
        ['languages', 'Languages', 'col-xs-2 col-filter', 'text', 'custom', 'filter'],
        ['zip_code', 'ZIP code or state', 'col-xs-2 col-filter', 'text', 'not-custom', 'filter'],
    ];

    readonly SPDescriptionColumns = [
        ['company', 'Company', 'original', 'desc-details custom', 'name'],
        // ['insurance', 'Compensation', 'translation', 'desc-details custom'],
        ['sub_category', 'Sub-Category', 'translation', 'desc-details custom'],
        ['application_duration_', 'Application duration', 'translation', 'desc-details custom'],
        ['age_group', 'Age group', 'translation', 'desc-details custom'],
    ];

    readonly ContraindicationsColumns = [
        ['serviceprovider', 'Service provider', 'col-xs-4 col-sp', 'text', 'custom', 'default'],
        ['contraindications', 'Contraindications (ICD-10)', 'col-xs-6 col-contrain', 'text', 'custom', 'default'],
        ['checked', 'Checked', 'col-xs-1 col-check', 'text', 'custom', 'filter'],
    ];

    readonly STEPTITLE = [
        '',
        'Filter the service providers',
        'Find matching service providers',
        'Check contraindications for this serviceprovider',
        'Generate evaluation report',
        'Generate evaluation report',
    ];

    constructor(
        public appService: AppService,
        public authService: AuthService,
        public baseService: BaseService,
        public questionnairesService: QuestionnairesService,
        public patientService: PatientService,
        public fb: FormBuilder,
        public patientsService: PatientsService,
        public route: ActivatedRoute,
        public translate: TranslateService,
        public router: Router,
        private sanitizer: DomSanitizer) {
        super(authService, router, baseService, appService);
        Window["AppComponent"] = this;
    }

    ngOnInit() {
        if (!this.languageSub) {
            this.languageSub = this.translate.onLangChange.subscribe(value => {
                if(this.lang === value.lang){
                    return true;
                }
                this.lang = value.lang;
                this.setInsurrancesCollection();
                // Only generate Preview when change Language if user didn't edit anything
                if(!this.previewHasBeenEditted && this.therapyStep === this.STEPS.PREVIEW_REPORT){
                    this.generatePreview();
                }
            });
        }
        /**
         * Get Filters
         */
        this.getData();
    }

    getData() {
        /**
         * Get Filters
         */
         this.patientService.getFilters(this.patientId)
         .subscribe(
             response => {
                 if (response['countries'] && response['countries'].length) {
                     this.countries = _.values(response['countries']);
                     this.selectedCountry = this.countries[0]['id'];
                 }
                 this.insurances = _.values(response['insurances']) || null;
                 this.setInsurrancesCollection();
                 if (this.questionnaires.length > 0) {
                     this.questionnaireId = this.questionnaires[0]['id'];
                 }
             }
         )
    }

    ngAfterViewInit() {
        this.patientSub = this.appService.subscribe('patient', data => {
            if (data['selectedDiagnosesAreUpdated']) {
                this.therapyStep = this.STEPS.FILTER_SERVICE_PROVIDER;
                return this.ngOnInit();
            }
        });
    }

    ngOnDestroy() {
        if (this.patientSub) {
            this.patientSub.unsubscribe();
        }
        if (this.languageSub) {
            this.languageSub.unsubscribe();
        }
    }

    onChangeInsurances(data) {

    }

    setInsurrancesCollection() {
        if (this.insurances.length) {
            this.insurancesCollection = [];
            this.insurances.forEach(item => {
                this.insurancesCollection.push({
                    'id': item.id,
                    'text': item['name_' + this.lang],
                });
            });
        }
    }

    goNextPage(back = false) {
        this.previousStep = back ? this.previousStep - 1 : this.therapyStep;
        const nextStep = back ? this.therapyStep - 1 : this.therapyStep + 1;
        switch (nextStep) {
            case this.STEPS.FIND_MATCHING_SERVICE_PROVIDER:
                if(back){
                    this.therapyStep = this.STEPS.FIND_MATCHING_SERVICE_PROVIDER ;
                    return;
                }
                this.countSelected = 0;
                this.getServiceProviders();
                break;
            case this.STEPS.CHECK_CONTRAINDICATION:
                if (this.dataUpdated) {
                    this.SPSelected = [];
                    this.contrainSelected = [];
                    this.contrainReviewed = [];
                    this.categorySelected = [];
                    this.dataUpdated = false;

                    this.serviceProviders.forEach(item => {
                        const SPSelected = item['service_providers'].filter(
                            data => data?.selected
                        );
                        const contrainSelected = item['service_providers'].filter(
                            data => data?.selected && data?.contraindications?.length > 0);
                        if(SPSelected.length){
                            this.SPSelected = this.SPSelected.concat(SPSelected);
                        }
                        if(contrainSelected.length){
                            this.contrainSelected = this.contrainSelected.concat(contrainSelected);
                        }
                    });
                }
                // Navigate to last step if have no item
                if (this.contrainSelected && this.contrainSelected.length === 0) {
                    if(back){
                        this.therapyStep = this.STEPS.FIND_MATCHING_SERVICE_PROVIDER;
                        return;
                    }
                    return this.generatePreview();
                }
                this.therapyStep = nextStep;
                break;

            case this.STEPS.PREVIEW_REPORT:
                this.generatePreview();
                break;

            case this.STEPS.LASTSTEP:
                this.previousStep = this.contrainSelected?.length ? this.STEPS.CHECK_CONTRAINDICATION : this.STEPS.FIND_MATCHING_SERVICE_PROVIDER;
                this.generateReport();
                break;
            default:
                this.therapyStep = nextStep;
                break;
        }
    }

    getServiceProviders() {
        /**
         * Get Patient Service Providers
         */
        this.isLoading = true;
        this.serviceProviders = new ServiceProviderCategory;
        const insurances = this.selectedInsurances ? this.selectedInsurances.toString() : '';
        this.patientService.getServiceProviders(this.patientId, this.selectedCountry, insurances, this.groupTherapy).pipe(
            finalize(() => this.isLoading = false))
            .subscribe(
                response => {
                    this.serviceProviders = response['categories'];
                    let _self = this;
                    _self.zipcodeFilters = [];
                    this.serviceProviders.forEach(item => {
                        const sp = item['service_providers'];
                        const zipCode = _.compact(_.map(sp, 'zip_code'));
                        const languages = _.flattenDeep(_.map(sp, 'languages'));

                        if (zipCode && zipCode !== '' && !_.has(_self.zipcodeFilters, zipCode)) {
                            _self.zipcodeFilters = _.union(_self.zipcodeFilters, zipCode);
                        }
                        if (languages && !_.isEmpty(languages) && languages.length) {
                            _self.languageFilters = _.uniqBy(_.union(_self.languageFilters, languages), function (lang) {
                                return lang.code;
                            });
                        }
                    });
                    this.therapyStep = this.STEPS.FIND_MATCHING_SERVICE_PROVIDER;
                }
            )
    }


    generateReport() {
        /**
         * Generate evaluation report
         */
        this.appService.isLoading = true;
        const size = 'a4';
        const data = {
            data: this.pdfContent,
            size: size,
            language: this.translate.currentLang,
            ids: JSON.stringify(_.map(this.SPSelected, 'pivot.id')),
        };
        this.patientService.generateReport(this.patientId, data).pipe(
            finalize(() => this.appService.isLoading = false))
            .subscribe(
                response => {
                    if (response['file']) {
                        this.appService.isLoading = false;
                        const document = response['file'];
                        return this.navigateDocumentTab.emit(document);
                    }
                    return this.generatePreview();
                }
            );
        return true;
    }

    generateHTMLContent(){
        this.pdfFullcontent = '';
        for(let i=0; i< this.pdfContent.length - 1; i++){
            let iconCRUD = '<i class="fal fa-edit report-data--section--icon edit-icon" attr-item-index="' + i + '"></i>';
            this.pdfFullcontent += _.toString(this.pdfContent[i].html + '<div class="report-data--section">' + iconCRUD + this.pdfContent[i].text + '</div>');
        }
        this.pdfFullcontent += _.toString(this.pdfContent[this.pdfContent.length - 1].html);
        return;
    }

    generatePreview(){
        let content = 'Automatically generated report';
        const size = 'a4';
        const data = {
            content: content,
            size: size,
            is_pdf: 0,
            // symptomMap: this.symptomMapContent(),
            language: this.translate.currentLang,
            ids: JSON.stringify(_.map(this.SPSelected, 'pivot.id')),
            questionnaire_id: this.questionnaireId
        };
        /**
         * Generate evaluation report
         */
        this.appService.isLoading = true;
        this.previewHasBeenEditted = false;
        this.patientService.generatePreview(this.patientId, data).pipe(
            finalize(() => this.appService.isLoading = false))
            .subscribe(
                response => {
                    this.therapyStep = this.STEPS.PREVIEW_REPORT;
                    if (response['file']) {
                        this.appService.isLoading = false;
                        const document = response['file'];
                        return this.navigateDocumentTab.emit(document);
                    }
                    this.pdfContent = response['content']?.data;
                    this.pdfStyleCss = response['content']?.css;
                    return this.generateHTMLContent();
                }
            );
        return true;
    }

    setFilter(name, value) {
        if (this.filterBy[name] === value) {
            this.filterBy[name] = null;
            return;
        }
        this.filterBy[name] = value;
    }

    isFilteredBy(item) {
        let isFilterLanguage = true;
        let isFilterZipcode = true;
        let _self = this;
        if (this.filterBy.languages && this.filterBy.languages.length > 0) {
            let dataLanguages = _.filter(item['languages'], function (lang) {
                return _self.filterBy.languages.includes(lang.code);
            });
            isFilterLanguage = dataLanguages.length > 0 ? true : false;
        }
        if (this.filterBy.zip_code && this.filterBy.zip_code.length > 0) {
            isFilterZipcode = this.filterBy.zip_code.includes(item['zip_code']);
        }
        return isFilterLanguage && isFilterZipcode;
    }

    toggleSPCategory(category, value) {
        if (!category.length) {
            return false;
        }
        category.forEach(item => {
            if (item['selected'] !== value) {
                item['selected'] = value;
                return this.selectSP(item, value);
            }
        });
    }

    selectSP(item, value) {
        this.dataUpdated = true;
        if (item.selected) {
            return this.countSelected++;
        }
        return this.countSelected--;
    }

    handleEvent($event){
        const index = $event.target.getAttribute('attr-item-index');
        if(!index){
            return;
        }
        const item = this.pdfContent[index];
        this.editingIndex = index;
        this.editingItem = {
            html: item.html,
            text: item.text
        };
        this.editItem($event, item, index);
    }

    editItem($event, item, index){
        this.editContent = item.text;
        this.showEditModal();
        return true;
    }

    saveItem(item){
        this.editingItem['text'] = this.editContent;
        this.pdfContent[this.editingIndex] = this.editingItem;
        this.previewHasBeenEditted = true;
        this.generateHTMLContent();
        return this.closeEdit(item);
    }

    closeEdit(item){
        this.editContent = '';
        this.editingIndex = -1;
        this.modalEdit.hide();
    }

    showEditModal(){
        this.modalEdit.config.backdrop = false;
        this.modalEdit.config.ignoreBackdropClick = true;
        this.modalEdit.config.keyboard = false;
        this.modalEdit.show();
    }
}
